import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// Components
import ChangePasswordForm from '../../components/ChangePasswordForm';

import cs from '../../components/commonStyle.css'
import s from './ChangePasswordContainer.css';

const ChangePasswordContainer = () => {

  const registeredType = useSelector(state => state?.account?.data?.userData?.type);
  const profileId = useSelector(state => state?.account?.data?.profileId);
  const initialValues = { registeredType, profileId };

  return (
    <Grid fluid className={'listingContainer'}>
      <Row>
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
          <ChangePasswordForm initialValues={initialValues} />
        </Col>
      </Row>
    </Grid>
  );
}

export default withStyles(cs, s)(ChangePasswordContainer);